import { DATE_SHORT_FORMAT } from '../../../../../../constants/date'
import { EntityStatus } from '../../../../../Entity'
import { RentalPortalApplicantIdentityCell } from '../../../../../RentalPortalApplicant'
import {
  TableCellBase,
  TableDateCell,
  TableEmptyCell,
} from '../../../../../Table'
import { RentalPortalApplicantPortalCell } from '../../../../RentalPortalApplicantPortalCell'
import { getApplicantWithHighlightBudget } from '../../../../RentalPortalApplicants'
import {
  RentalPortalMatchChipsCell,
  RentalPortalMatchCriteriaPopover,
  RentalPortalMatchFitCell,
} from '../../../../RentalPortalMatch'
import { RentalPortalWaitingOnCell } from '../../../../RentalPortalWaitingOnCell'
import {
  LISTING_APPLICANT_STAGES,
  ListingApplicantColumnName,
} from '../RentalPortalListingProfileApplicants.constants'

export function renderListingProfileApplicantsCell({
  item,
  name,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case ListingApplicantColumnName.Applicant:
      return (
        <RentalPortalApplicantIdentityCell
          {...restProps}
          applicant={getApplicantWithHighlightBudget(item)}
        />
      )

    case ListingApplicantColumnName.Chips:
      return item.match ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchChipsCell match={item.match} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case ListingApplicantColumnName.Fit:
      return value ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchCriteriaPopover match={value}>
            <RentalPortalMatchFitCell match={value} />
          </RentalPortalMatchCriteriaPopover>
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case ListingApplicantColumnName.Stage:
      return LISTING_APPLICANT_STAGES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={LISTING_APPLICANT_STAGES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case ListingApplicantColumnName.Received:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )

    case ListingApplicantColumnName.WaitingOn:
      return (
        <RentalPortalWaitingOnCell {...restProps} attention={item.attention} />
      )

    case ListingApplicantColumnName.Portal:
      return value ? (
        <RentalPortalApplicantPortalCell {...restProps} applicant={item} />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    default:
      return <TableEmptyCell {...restProps} />
  }
}
